import requestv2 from "~/utils/http-v2";

const payApi = {
	gets : async (params) => {
		const url = 'v2/pays';
		return await requestv2.get(url, {params});
	},
	revenues : async (params) => {
		const url = `v2/pays/revenues/${params.id}`;
		return await requestv2.get(url, {params});
	},
	manager : async (params) => {
		const url = `v2/pays/manager/${params.id}`;
		return await requestv2.get(url, {params});
	},
	expense : async (params) => {
		const url = `v2/pays/expense/${params.id}`;
		return await requestv2.get(url, {params});
	},
	report : async (params) => {
		const url = `v2/pays/report`;
		return await requestv2.get(url, {params});
	},
	workday : async (params) => {
		const url = `v2/pays/workday/${params.id}`;
		return await requestv2.get(url, {params});
	},
};

export default payApi;